import { useTranslation } from 'react-i18next';
import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

//进销存报表
export default () => {
    
const { t } = useTranslation();
return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}